module.exports = "/_next/static/images/financial-accounting-service-3-ca22ece22dc07d5d3f9d96e273649804.webp";